import React, { ChangeEvent } from 'react';
import { Field } from 'redux-form';
import classNames from 'clsx';

import { CheckboxControl } from 'app/components/Controls';
import { HiProConsentWithTextDto } from 'app/shared/interfaces/HiProApplicationResponse.interface';
import { InstallmentsEnum } from 'app/shared/enums';
import { haveToBeTrue, required } from 'app/validators';

import { useStyles } from './ConsentField.styles';

export default function ConsentField({
  consent,
  onChange,
  showAllLabel,
}: {
  consent: HiProConsentWithTextDto;
  onChange?: (value: ChangeEvent<HTMLInputElement>) => void;
  showAllLabel?: boolean;
}) {
  const classes = useStyles();

  const getLabel = (label: string) => {
    const link = label.match(/\[(.*?)\]/);

    if (!link) {
      return label;
    }

    const linkElement = `<a target="_blank" rel="noopener noreferrer" href="${link[1]}">${link[1]}</a>`;

    return label.replace(/\[(.*?)\)/, linkElement);
  };

  return (
    <div className={classes.consentWrapper}>
      {consent.mandatory ? (
        <span
          className={classNames(
            classes.requiredFielAsterisk,
            classes.consentRequired
          )}
        >
          {InstallmentsEnum.Asterisk}
        </span>
      ) : null}
      <Field
        component={CheckboxControl}
        name={consent.code}
        label={
          consent.textLong ? getLabel(consent.textLong) : getLabel(consent.text)
        }
        validate={consent.mandatory ? [required, haveToBeTrue] : []}
        width={'full'}
        onChange={onChange}
        showAllLabel={showAllLabel}
      />
    </div>
  );
}
